export function isEmptyOrSpaces(str) {
  if (typeof str === 'string') return str === '' || str.match(/^\s*$/) !== null;
  return false;
}
